import React from 'react';
import { BpfChangelogListing } from 'modules/stages';
import { PageContainer } from 'components/shared/Page/PageContainer';

export const AuditLog = () => {
  return (
    <PageContainer title="Audit Log">
      <BpfChangelogListing />
    </PageContainer>
  );
};
